import {
  CmpTypographyField,
  CmpTextField,
  CmpDatePicker,
  CmpCheckboxField,
} from "../../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
export default function WmsHead({
  xref,
  vRdxHead,
  xErrorMsg,
  vRdxuserLoc,
  fLocation,
  fDate,
}) {
  return (
    <form id="WmsStockAdjustmentHead">
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0, md: 0 }}
        columnSpacing={{ xs: 0, sm: 0, md: 1 }}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        className="align-items-start"
      >
        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"Doc Type"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpTextField
            xtabIndex={"1"}
            xValue={vRdxHead.DocType}
            xVariant={"standard"}
            xType={"text"} // text/number/password
            xName={"DocType"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsg.DocType === "" ? false : true}
            xErrorMessage={xErrorMsg.DocType}
          />
        </Grid>
        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"Doc Name"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpTextField
            xtabIndex={"1"}
            xValue={vRdxHead.DocName}
            xVariant={"standard"}
            xType={"text"} // text/number/password
            xName={"DocName"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsg.DocName === "" ? false : true}
            xErrorMessage={xErrorMsg.DocName}
          />
        </Grid>
        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"Unloading Bin"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpTextField
            xtabIndex={"1"}
            xValue={vRdxHead.UnloadingBin}
            xVariant={"standard"}
            xType={"text"} // text/number/password
            xName={"UnloadingBin"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsg.UnloadingBin === "" ? false : true}
            xErrorMessage={xErrorMsg.UnloadingBin}
          />
        </Grid>
        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"Unloading Bin"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpTextField
            xtabIndex={"1"}
            xValue={vRdxHead.UnloadingBinName}
            xVariant={"standard"}
            xType={"text"} // text/number/password
            xName={"UnloadingBinName"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsg.UnloadingBinName === "" ? false : true}
            xErrorMessage={xErrorMsg.UnloadingBinName}
          />
        </Grid>
        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"Location"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpTextField
            xtabIndex={"2"}
            xValue={vRdxHead.Loc}
            xVariant={"standard"}
            xType={"text"} // text/number/password
            xName={"Loc"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsg.Loc === "" ? false : true}
            xErrorMessage={xErrorMsg.Loc}
          />
          {/* <CmpSelectBox
            xtabIndex={"2"}
            xLabelText="Location"
            xVariant={"standard"}
            xValue={vRdxHead.Loc}
            xOnChange={fLocation}
            xName={"Loc"}
            xData={vRdxuserLoc}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsg.Loc === "" ? false : true}
            xErrorMessage={xErrorMsg.Loc}
            xDisable={true}
          /> */}
        </Grid>
        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"LocName"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpTextField
            xtabIndex={"2"}
            xValue={vRdxHead.LocName}
            xVariant={"standard"}
            xType={"text"} // text/number/password
            xName={"LocName"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsg.LocName === "" ? false : true}
            xErrorMessage={xErrorMsg.LocName}
          />
        </Grid>
        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"Doc.No"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpTextField
            xref={xref}
            xtabIndex={"3"}
            xValue={vRdxHead.DocNo}
            xType={"text"} // text/number/password
            xName={"DocNo"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsg.DocNo === "" ? false : true}
            xErrorMessage={xErrorMsg.DocNo}
          />
          {/* <CmpInputField
                xref={xref}
                xtabIndex={"3"}
                xValue={vRdxHead.ReferenceNo}
                xType={"text"} // text/number/password
                xName={"ReferenceNo"}
                xReadOnly={false}
                xOnChange={fReferenceNo}
                xOnKeyUp={fReferenceNo_Enter}
                xError={xErrorMsg.ReferenceNo === "" ? false : true}
                xErrorMessage={xErrorMsg.ReferenceNo}
              /> */}
        </Grid>
        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"Auto"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpCheckboxField
            xChecked={vRdxHead.Auto == "A"}
            xOnChange={""}
            xDisabled={true}
            xName={"Auto"}
            xNameField={"Auto"}
            xError={xErrorMsg.Auto === "" ? false : true}
            xErrorMessage={xErrorMsg.Auto}
          />
        </Grid>
        <Grid item xs={3} sm={2} md={2} lg={2} className="mt-2">
          <CmpTypographyField xcomponent={"span"} xText={"Date"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4} className="mt-2">
          <CmpDatePicker
            xtabIndex={"4"}
            xLabelText={"Date"}
            xValue={vRdxHead.Date}
            xOnChange={fDate}
            xName={"Date"}
            xError={xErrorMsg.Date === "" ? false : true}
            xErrorMessage={xErrorMsg.Date}
          />
          {/* <CmpDatePickerField
                xtabIndex={"4"}
                xValue={vRdxHead.Date}
                xOnChange={fDate}
                xName={"Date"}
                xError={xErrorMsg.Date === "" ? false : true}
                xErrorMessage={xErrorMsg.Date}
              /> */}
        </Grid>
      </Grid>
    </form>
  );
}
